import React from 'react';
import {getLeagueByRating} from '../../../utils/rating/getLeagueByRating';
import {getPlaceIconPath} from '../../../utils/gameEnd/getPlaceIconPath';
import {LEAGUE_CONFIGS} from '../../../configs/leagues';
import {MINUS_SIGN} from '../../../constants/text';
import './RatingCrystalsPage.css';

/**
 * Дату берем из dayKey — это игровой день, ЗА который начислено. Он и есть
 * то, что игроку интересно; createdAt — лишь момент, когда сервер отработал
 * (fallback для старых записей)
 */
const formatRewardDate = (reward) => {
  const source = reward.dayKey || reward.createdAt;
  if (!source) return '—';
  const date = new Date(source);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('ru-RU', {day: 'numeric', month: 'long', year: 'numeric'});
};

const GLORY_PLACE_TITLES = {
  1: '1-е место в Зале славы',
  2: '2-е место в Зале славы',
  3: '3-е место в Зале славы',
};

/**
 * Строка истории «Кристаллы за рейтинг»: дата, за что и сколько кристаллов,
 * и как изменился рейтинг. Используется и на странице истории (в профиле и в
 * админке), и в модалке напоминания в главном меню.
 */
export const RatingCrystalsRewardRow = ({reward, showUserName = false, isCompact = false}) => {
  const leagueName = reward.leagueId
    ? LEAGUE_CONFIGS.find((league) => league.id === reward.leagueId)?.name
    : null;
  const leagueIconPath = reward.leagueId
    ? LEAGUE_CONFIGS.find((league) => league.id === reward.leagueId)?.iconPath
    : null;

  return (
    <div className={`rating-crystals-row${isCompact ? ' rating-crystals-row_compact' : ''}`}>
      <div className={'rating-crystals-row_header'}>
        <span className={'rating-crystals-row_date'}>{formatRewardDate(reward)}</span>
        {showUserName && (
          <span className={'rating-crystals-row_user'}>{reward.userName || reward.userId}</span>
        )}
        <span className={'rating-crystals-row_total text-crystals'}>
          +{reward.crystals}
          <img className={'rating-crystals-row_crystal-icon'} src={'/img/icons/crystal.png'} alt={'Кристаллы'}/>
        </span>
      </div>

      <div className={'rating-crystals-row_reasons'}>
        {reward.leagueCrystals > 0 && (
          <span className={'rating-crystals-row_reason'}>
            {leagueIconPath && (
              <img className={'rating-crystals-row_league-icon'} src={leagueIconPath} alt={leagueName}/>
            )}
            <span>{leagueName}</span>
            <span className={'text-crystals'}>+{reward.leagueCrystals}</span>
          </span>
        )}
        {reward.gloryCrystals > 0 && (
          <span className={'rating-crystals-row_reason'}>
            {/* Значок места — тот же, что в итогах матча и в Зале славы */}
            {getPlaceIconPath(reward.gloryPlace - 1) && (
              <img
                className={'rating-crystals-row_place-icon'}
                src={getPlaceIconPath(reward.gloryPlace - 1)}
                alt={`${reward.gloryPlace} место`}
              />
            )}
            <span>{GLORY_PLACE_TITLES[reward.gloryPlace] || 'Зал славы'}</span>
            <span className={'text-crystals'}>+{reward.gloryCrystals}</span>
          </span>
        )}
      </div>

      {reward.ratingDelta !== 0 && (
        <div className={'rating-crystals-row_rating'}>
          <span className={'rating-crystals-row_rating-label'}>Рейтинг:</span>
          <span className={'text-rating'}>{MINUS_SIGN}{Math.abs(reward.ratingDelta)}</span>
          <span className={'rating-crystals-row_rating-arrow'}>→</span>
          <span className={'rating-crystals-row_rating-value'}>{reward.ratingAfter}</span>
          <img
            className={'rating-crystals-row_rating-league-icon'}
            src={getLeagueByRating(reward.ratingAfter).iconPath}
            alt={getLeagueByRating(reward.ratingAfter).name}
            title={getLeagueByRating(reward.ratingAfter).name}
          />
        </div>
      )}
    </div>
  );
};

export default RatingCrystalsRewardRow;
